module.exports = __webpack_public_path__ + "img/bnr-today-sp@2x.578463c7.jpg";